<template>
    <div>
        <img class="img-fluid" src="@/assets/undraw_page_not_found.svg">
    </div>
</template>

<script>
export default {
    name: 'NotFound',
	metaInfo: {
		title: "404",
	},
}
</script>

<style scoped>

</style>